import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Usersetting } from '../model/usersetting';

@Injectable({
  providedIn: 'root'
})
export class UsersettingsService {

  constructor(private http:HttpClient) { }

  //get the user settings from the server
  // GET	    /organization/{organizationId}/person/{personId}/settings	
  getUserSettings(personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Usersetting>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId+'/settings',httpOptions);
  }

  //update the user settings
  // PUT	    /organization/{organizationId}/person/{personId}/settings
  updateUserSettings(personId:string,data){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId+'/settings',data,httpOptions);
  }
}
